module.exports = __webpack_public_path__ + "static/2. The Execution Challenge-db3b89e6b662c66befa2be7c74d823d3.png";